import { ACTIONS } from '../Actions/loadingActions';

const initialState = {
  isLoading: false,
};

const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.STATUS:
      return { ...state, isLoading: action.payload };

    default:
      return state;
  }
};

export default loadingReducer;
